import { render } from "./LeukocytesNCL2.vue?vue&type=template&id=09cee2ea&scoped=true"
import script from "./LeukocytesNCL2.vue?vue&type=script&lang=js"
export * from "./LeukocytesNCL2.vue?vue&type=script&lang=js"

import "./LeukocytesNCL2.vue?vue&type=style&index=0&id=09cee2ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cee2ea"]])

export default __exports__